import { render, staticRenderFns } from "./el-option-node.vue?vue&type=template&id=87aef2a0&"
import script from "./el-option-node.vue?vue&type=script&lang=js&"
export * from "./el-option-node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports